// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.voice-recorder {
  max-width: 600px;
  margin: 0 auto;
}

.voice-header {
  text-align: center;
  margin-bottom: 32px;
}

.voice-header h2 {
  margin: 0 0 8px 0;
  color: #333;
  font-size: 28px;
  font-weight: 700;
}

.voice-header p {
  color: #666;
  font-size: 15px;
  margin: 0;
}

.voice-recording-section,
.voice-preview-section {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.recording-instructions {
  text-align: center;
  padding: 20px;
  background: #f8f9fa;
  border-radius: 8px;
}

.recording-instructions p {
  margin: 0;
  color: #666;
  font-size: 14px;
  line-height: 1.6;
}

.recording-controls {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.record-button {
  padding: 20px 40px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: all 0.3s ease;
}

.record-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
}

.record-icon {
  font-size: 24px;
}

.recording-active {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
}

.recording-indicator {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #e74c3c;
  font-weight: 600;
  font-size: 16px;
}

.pulse {
  width: 12px;
  height: 12px;
  background: #e74c3c;
  border-radius: 50%;
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(1.2);
  }
}

.recording-time {
  font-size: 32px;
  font-weight: 700;
  color: #333;
  font-variant-numeric: tabular-nums;
}

.stop-button {
  padding: 12px 32px;
  background: #e74c3c;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.stop-button:hover {
  background: #c0392b;
  transform: translateY(-2px);
}

.voice-consent {
  margin-top: 16px;
}

.consent-checkbox {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  cursor: pointer;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  transition: background 0.3s ease;
}

.consent-checkbox:hover {
  background: #e9ecef;
}

.consent-checkbox input[type="checkbox"] {
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-top: 2px;
  flex-shrink: 0;
}

.consent-checkbox span {
  color: #333;
  font-size: 14px;
  line-height: 1.5;
}

.voice-preview-section h3 {
  margin: 0 0 16px 0;
  color: #333;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
}

.audio-preview {
  width: 100%;
  margin: 16px 0;
}

.preview-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  align-items: center;
}

.voice-recorder .re-record-button,
.voice-recorder .continue-button {
  padding: 0;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  margin: 0;
  flex-shrink: 0;
  text-align: center;
  white-space: nowrap;
  font-family: inherit;
  height: 44px;
  width: 130px;
  padding-left: 24px;
  padding-right: 24px;
}

.voice-recorder .re-record-button {
  background: #6c757d;
  color: white;
}

.voice-recorder .re-record-button:hover {
  background: #5a6268;
  transform: translateY(-2px);
}

.voice-recorder .continue-button {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.voice-recorder .continue-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
}

.voice-recorder .continue-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.error-message {
  margin-top: 16px;
  padding: 12px;
  background: #fff5f5;
  border: 1px solid #feb2b2;
  border-radius: 8px;
  color: #e74c3c;
  font-size: 14px;
  text-align: center;
}

`, "",{"version":3,"sources":["webpack://./src/components/onboarding/VoiceRecorder.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,qBAAqB;EACvB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB","sourcesContent":[".voice-recorder {\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.voice-header {\n  text-align: center;\n  margin-bottom: 32px;\n}\n\n.voice-header h2 {\n  margin: 0 0 8px 0;\n  color: #333;\n  font-size: 28px;\n  font-weight: 700;\n}\n\n.voice-header p {\n  color: #666;\n  font-size: 15px;\n  margin: 0;\n}\n\n.voice-recording-section,\n.voice-preview-section {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.recording-instructions {\n  text-align: center;\n  padding: 20px;\n  background: #f8f9fa;\n  border-radius: 8px;\n}\n\n.recording-instructions p {\n  margin: 0;\n  color: #666;\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n.recording-controls {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n}\n\n.record-button {\n  padding: 20px 40px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 12px;\n  font-size: 18px;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  transition: all 0.3s ease;\n}\n\n.record-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);\n}\n\n.record-icon {\n  font-size: 24px;\n}\n\n.recording-active {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  width: 100%;\n}\n\n.recording-indicator {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  color: #e74c3c;\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.pulse {\n  width: 12px;\n  height: 12px;\n  background: #e74c3c;\n  border-radius: 50%;\n  animation: pulse 1.5s ease-in-out infinite;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.5;\n    transform: scale(1.2);\n  }\n}\n\n.recording-time {\n  font-size: 32px;\n  font-weight: 700;\n  color: #333;\n  font-variant-numeric: tabular-nums;\n}\n\n.stop-button {\n  padding: 12px 32px;\n  background: #e74c3c;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.stop-button:hover {\n  background: #c0392b;\n  transform: translateY(-2px);\n}\n\n.voice-consent {\n  margin-top: 16px;\n}\n\n.consent-checkbox {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  cursor: pointer;\n  padding: 16px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  transition: background 0.3s ease;\n}\n\n.consent-checkbox:hover {\n  background: #e9ecef;\n}\n\n.consent-checkbox input[type=\"checkbox\"] {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  margin-top: 2px;\n  flex-shrink: 0;\n}\n\n.consent-checkbox span {\n  color: #333;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.voice-preview-section h3 {\n  margin: 0 0 16px 0;\n  color: #333;\n  font-size: 20px;\n  font-weight: 600;\n  text-align: center;\n}\n\n.audio-preview {\n  width: 100%;\n  margin: 16px 0;\n}\n\n.preview-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n  align-items: center;\n}\n\n.voice-recorder .re-record-button,\n.voice-recorder .continue-button {\n  padding: 0;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n  margin: 0;\n  flex-shrink: 0;\n  text-align: center;\n  white-space: nowrap;\n  font-family: inherit;\n  height: 44px;\n  width: 130px;\n  padding-left: 24px;\n  padding-right: 24px;\n}\n\n.voice-recorder .re-record-button {\n  background: #6c757d;\n  color: white;\n}\n\n.voice-recorder .re-record-button:hover {\n  background: #5a6268;\n  transform: translateY(-2px);\n}\n\n.voice-recorder .continue-button {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n}\n\n.voice-recorder .continue-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);\n}\n\n.voice-recorder .continue-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.error-message {\n  margin-top: 16px;\n  padding: 12px;\n  background: #fff5f5;\n  border: 1px solid #feb2b2;\n  border-radius: 8px;\n  color: #e74c3c;\n  font-size: 14px;\n  text-align: center;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
